var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInnovateAtScale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Innovate_at_scale",
    "data-name": "Innovate at scale",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trending_up-24px_3_",
    "data-name": "trending_up-24px (3)",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M0,0H48V48H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M26.2,6l4.122,4.122-8.784,8.784-7.2-7.2L3,23.062,5.538,25.6l8.8-8.8,7.2,7.2,11.34-11.322L37,16.8V6Z",
    transform: "translate(3 -0.8)",
    fill: "#24397a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1062",
    "data-name": "Rectangle 1062",
    width: 4,
    height: 6,
    transform: "translate(8 34)",
    fill: "#24397a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1063",
    "data-name": "Rectangle 1063",
    width: 4,
    height: 12,
    transform: "translate(22 28)",
    fill: "#24397a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1064",
    "data-name": "Rectangle 1064",
    width: 4,
    height: 20,
    transform: "translate(36 20)",
    fill: "#24397a"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovateAtScale);
export default __webpack_public_path__ + "static/media/innovate_at_scale.c6dadb7cb8da6e0cf4f43a98ecc571e0.svg";
export { ForwardRef as ReactComponent };